import { downloadBytes, encodeUtf8Csv } from './downloadFile';

export function escapeCsvCell(value) {
  const text = value == null ? '' : String(value).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  return `"${text.replace(/"/g, '""')}"`;
}

/** Force Excel / mobile viewers to treat IDs and phone numbers as text, not scientific notation. */
export function forceCsvText(value) {
  if (value == null || value === '') return '';
  const text = String(value);
  if (/^[\d+\-().\s]+$/.test(text) && text.replace(/\D/g, '').length >= 8) {
    return `\t${text}`;
  }
  if (/^[0-9a-f-]{32,36}$/i.test(text)) {
    return `\t${text}`;
  }
  return text;
}

export function formatAuditCsvValue(key, value) {
  if (value == null || value === '') return '';
  if (key === 'created_at') {
    try {
      return new Date(value).toISOString();
    } catch {
      return String(value);
    }
  }
  if (key === 'metadata') {
    try {
      return JSON.stringify(value ?? {});
    } catch {
      return String(value);
    }
  }
  if (key === 'actor_id' || key === 'entity_id' || key === 'id') {
    return forceCsvText(value);
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

export function buildCsvFromRows(headers, rows, { formatValue = null } = {}) {
  const fmt = formatValue || ((_, value) => (value == null ? '' : String(value)));
  const lines = [
    headers.map((h) => escapeCsvCell(h)).join(','),
    ...rows.map((row) => row.map((value, i) => escapeCsvCell(fmt(headers[i], value, row))).join(',')),
  ];
  return lines.join('\r\n');
}

export async function downloadCsvContent(content, filename) {
  const bytes = encodeUtf8Csv(content);
  await downloadBytes(bytes, filename, 'text/csv;charset=utf-8');
}

export const AUDIT_CSV_HEADERS = {
  created_at: 'Created At',
  action: 'Action',
  actor_id: 'Actor ID',
  actor_role: 'Actor Role',
  entity_type: 'Entity Type',
  entity_id: 'Entity ID',
  metadata: 'Metadata',
};

export async function exportAuditLogsCsv(rows, enabledColumns, filename) {
  const keys = Object.entries(enabledColumns).filter(([, enabled]) => enabled).map(([key]) => key);
  if (keys.length === 0 || rows.length === 0) return false;

  const headers = keys.map((key) => AUDIT_CSV_HEADERS[key] || key);
  const dataRows = rows.map((row) => keys.map((key) => formatAuditCsvValue(key, row[key])));
  const csv = buildCsvFromRows(headers, dataRows);
  await downloadCsvContent(csv, filename);
  return true;
}
